import { render, staticRenderFns } from "./confirm_new.vue?vue&type=template&id=32e89764&scoped=true&"
import script from "./confirm_new.vue?vue&type=script&lang=js&"
export * from "./confirm_new.vue?vue&type=script&lang=js&"
import style0 from "./confirm_new.vue?vue&type=style&index=0&id=32e89764&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e89764",
  null
  
)

export default component.exports